module.exports = __webpack_public_path__ + "static/header-mockup-4a69da8527bbc4bc7c4d5c651c98917d.png";